import { PRESCRIPTION_INTEGRATION } from '@abiglobalhealth/go-types'

import { usePrescription } from '@/hooks/usePrescription'

import { DefaultForm } from './DefaultForm'
import { DoseSpotForm } from './DoseSpotForm'
import { SignatureRXForm } from './SignatureRXForm'

export const UserAddressForm = () => {
  const { prescription } = usePrescription()

  switch (prescription?.integration) {
    case PRESCRIPTION_INTEGRATION.DOSE_SPOT:
      return <DoseSpotForm />
    case PRESCRIPTION_INTEGRATION.SIGNATURERX:
      return <SignatureRXForm />
    default:
      return <DefaultForm />
  }
}
